import React from 'react';
import cx from 'classnames';
import { Chips } from '../Chips';
import styles from './style.module.css';

interface Props {
  items: string[];
  onRemove: (itemIndex: any, normalizeId: string, category: number) => void;
  numberOfProducts: number;
  location?: string;
  onRemoveChekboxChecked: any;
  searchValue?: string;
  order?: any;
  partCategories?: any;
  partSubCategories?: any[];
  partSubSubCategories?: any[];
}

const headerStyle = cx(
  'normal f16 f20-ns fw2 ma0 mt8 mt0-ns abbey',
  styles.breakText,
  styles.title,
);
const BoldTextWrapper: React.FC = ({ children }) => <span className="fw7 abbey">{children}</span>;

export const SearchWithChips = ({
  items,
  onRemove,
  numberOfProducts = 0,
  onRemoveChekboxChecked,
  searchValue,
  order,
  partCategories,
  partSubCategories,
  partSubSubCategories,
}: Props) => {
  const text =
    !numberOfProducts || numberOfProducts < 2 ? 'resultado encontrado' : 'resultados encontrados';

  return (
    <section className="mt40-l mt40-m mt40-ns mt-0">
      <h5 className={headerStyle}>
        <BoldTextWrapper>{numberOfProducts || 0}</BoldTextWrapper> {text}
        <span className="ml40-ns" />
      </h5>
      <Chips
        order={order}
        searchValue={searchValue}
        items={items}
        onRemove={onRemove}
        onRemoveChekboxChecked={onRemoveChekboxChecked}
        partCategories={partCategories}
        partSubCategories={partSubCategories}
        partSubSubCategories={partSubSubCategories}
      />
    </section>
  );
};
